import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { assertDefined } from "core/functions";
import { KeyboardService } from "common/keyboard.service";
import { UserResource } from "core/stages-client";
import { HttpErrorResponse } from "@angular/common/http";
import { FormService } from "common/form/form.service";
import { NewDialogComponent } from "common/newdialog/dialog.component";

@Component({
	selector: "stages-start-otp-dialog",
	templateUrl: "./otp-dialog.component.html",
	styleUrls: ["./otp-dialog.component.scss"],
})
export class OtpDialogComponent implements OnInit {
	otpFormGroup: UntypedFormGroup = new UntypedFormGroup({});
	needsCode = false;
	oldType!: stages.core.crypOtpType;
	newType!: stages.core.crypOtpType;
	changeOtpInProgress = false;

	resultURL?: string | null;

	@ViewChild("dialog", { static: true })
	dialog!: NewDialogComponent;

	constructor(
		private route: ActivatedRoute,
		private readonly userResource: UserResource,
		private readonly keyboardService: KeyboardService,
		private readonly formService: FormService,
	) {}

	ngOnInit(): void {
		this.oldType = this.route.snapshot.paramMap.get("oldType")! as stages.core.crypOtpType;
		this.newType = this.route.snapshot.paramMap.get("newType")! as stages.core.crypOtpType;
		this.otpFormGroup.addControl("oldPassword", new UntypedFormControl("", [Validators.required]));
		this.otpFormGroup.addControl("code", new UntypedFormControl(""));
	}

	onKeyUp(event: KeyboardEvent): void {
		if (!this.keyboardService.isReturnKeyPressed(event)) {
			return;
		}
		this.onSave();
	}

	onCancel(): void {
		this.dialog.close();
	}

	onSave(): void {
		this.changeOtpInProgress = true;
		const password = this.otpFormGroup.get("oldPassword") ? this.otpFormGroup.get("oldPassword")!.value : "";
		const securityCode = this.otpFormGroup.get("code") ? this.otpFormGroup.get("code")!.value : undefined;
		this.userResource
			.changeOtpType(this.newType, {
				newPassword: password,
				oldPassword: password,
				securityCode: securityCode,
			})
			.then(() => {
				this.changeOtpInProgress = false;
				this.dialog.close();
			}, this.handleChangePasswordError(this.otpFormGroup.controls));
	}

	handleChangePasswordError(abstractControls: Record<string, AbstractControl>): (response: HttpErrorResponse) => void {
		return (response) => {
			this.changeOtpInProgress = false;
			if (response.status === 422 && response.error.fieldNames.indexOf("code") > -1) {
				this.needsCode = true;
				if (response.error.validationMessage.startsWith("otpauth://")) {
					this.resultURL = response.error.validationMessage;
				}
			}
			this.formService.setServerSideErrorsOnFormControls(abstractControls)(response);
		};
	}

	hasErrorAfterEditing(controlName: string, error: string): boolean {
		const control = assertDefined(this.otpFormGroup.get(controlName));
		return control.errors && control.errors[error] && (control.dirty || control.touched);
	}

	showCodeInput(): boolean {
		return this.needsCode;
	}

	isInProgress(): boolean {
		return this.changeOtpInProgress;
	}

	getResultURL(): string | null | undefined {
		return this.resultURL;
	}
}
